export const countries = [
  { code: 'CZ', label: 'Czech Republic', phone: '420' },
  { code: 'PL', label: 'Poland', phone: '48' },
  { code: 'SK', label: 'Slovakia', phone: '421' },
];
